/**
 * This reducer is used for validating products while adding to cart
 */
 import {
    GET_USER_LIST,
    GET_USER_LIST_SUCCESS,
    GET_USER_LIST_FAILURE,
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

const initialState = {
    adminUserList: [],
    loading: false,
    statusCode: 0,
    statusMessage: '',
};

const userListReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_LIST:
            return {
                ...state,
                //   adminUserList: [],
                loading: false,
            };
        case GET_USER_LIST_SUCCESS:
            return {
                ...state,
                adminUserList: action.adminUserList?.userListForTemplateShare
                    ? action.adminUserList.userListForTemplateShare
                    : [],
                adminUser: action.adminUserList,
                totalRecords: action.adminUserList.totalRecords,
                status: action.adminUserList.statusCode,
                sortOrder: action.adminUserList.sortOrder,
                sortParam: action.adminUserList.sortParam,
                loading: true,
            };
        case GET_USER_LIST_FAILURE:
            return {
                ...state,
                adminUserList: [],
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        default: {
            return { ...state };
        }
    }
};

export default userListReducer;
